import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IGetMerchantWithLatestMovementDetail {
    id: string
    currency: string;
}

async function getMerchantWithLatestMovementDetail(
    { id, currency }: IGetMerchantWithLatestMovementDetail
): Promise<any> {
    try {
        return (await axiosInstance.get(`/Merchant/GetMerchantWithLatestMovementDetail/${id}/${currency}`))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetMerchantWithLatestMovementDetail() {
    return useMutation<any, Error, IGetMerchantWithLatestMovementDetail>(
        (variables) => getMerchantWithLatestMovementDetail(variables)
    );
}
